import React, { useEffect, useRef, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import axios from "axios";
import BASEURL from "../../pages/Utils/Baseurl";
import GoogleMapKey from "../../pages/Utils/googleMapKey";
import image from "../../../src/assest/images/location.png";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const CameraMap = () => {
  const [lists, setLists] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  // Initial map center set to Bhaurin (Bahrain) coordinates.
  // This will be the default view if no employee locations are loaded or if lists is empty.
  const [mapCenter, setMapCenter] = useState({ lat: 26.0667, lng: 50.5577 });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [markerIcon, setMarkerIcon] = useState(null);

  const fetchCoordinates = async () => {
    const query = `
      query{ 
        liveLocation{ 
          employee{ 
            id 
            employeeName 
          }     
          checkIn{
            checkInTime
            checkInDate
            checkOuts{
              checkOutTime
              checkOutTime
            }
          }
          latitude 
          longitude 
        }
      }
    `;

    try {
      setLoading(true);
      const result = await axios.post(BASEURL, { query });

      const mappedLocations = await result?.data?.data?.liveLocation?.map(
        (user) => ({
          lat: parseFloat(user.latitude),
          lng: parseFloat(user.longitude),
          employeeName: user?.employee?.employeeName || "N/A",
          checkInTime: user?.checkIn?.checkInTime || "N/A",
          checkOutTime: user?.checkIn?.checkOuts?.[0]?.checkOutTime || "N/A",
        })
      );

      setLists(mappedLocations);
      setLoading(false);
    } catch (err) {
      setError("Failed to load employee locations.");
      setLists([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoordinates();
  }, []);

  const mapRef = useRef(null);

  const onLoad = (map) => {
    mapRef.current = map;

    // Setup marker icon after Google API is ready
    if (window.google) {
      const icon = {
        url: image,
        scaledSize: new window.google.maps.Size(40, 40),
      };
      setMarkerIcon(icon);
    }

    // Fit bounds to markers only if there are locations fetched.
    // If no locations, the map will stay centered at `mapCenter`.
    if (lists?.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      lists.forEach((loc) => bounds.extend({ lat: loc.lat, lng: loc.lng }));
      map.fitBounds(bounds);
    }
  };

  return (
    <div>
      <h2>Employee Live Locations</h2>

      {loading && <p>Loading map data...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && (
        <LoadScript googleMapsApiKey={GoogleMapKey}>
          <GoogleMap
            onLoad={onLoad}
            mapContainerStyle={containerStyle}
            center={mapCenter} // Map will initially center here
            zoom={10} // Initial zoom level; adjust as needed for a wider view of Bhaurin
          >
            {markerIcon &&
              lists.map((location, index) => (
                <Marker
                  key={index}
                  position={{ lat: location.lat, lng: location.lng }}
                  onClick={() => setSelectedShop(location)}
                  icon={markerIcon}
                  label={{
                    text: location?.employeeName,
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                />
              ))}

            {selectedShop && (
              <InfoWindow
                position={{ lat: selectedShop?.lat, lng: selectedShop?.lng }}
                onCloseClick={() => setSelectedShop(null)}
              >
                <div
                  style={{
                    minWidth: "220px",
                    fontFamily: "Arial, sans-serif",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <h3
                    style={{
                      margin: "0 0 8px",
                      fontSize: "16px",
                      color: "#2c3e50",
                    }}
                  >
                    👤 {selectedShop?.employeeName}
                  </h3>
                  <p
                    style={{
                      margin: "4px 0",
                      fontSize: "14px",
                      color: "#34495e",
                    }}
                  >
                    🕓 <strong>Check-In:</strong> {selectedShop?.checkInTime}
                  </p>
                  <p
                    style={{
                      margin: "4px 0",
                      fontSize: "14px",
                      color: "#34495e",
                    }}
                  >
                    🕔 <strong>Check-Out:</strong> {selectedShop?.checkOutTime}
                  </p>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        </LoadScript>
      )}
    </div>
  );
};

export default CameraMap;